module.exports = __webpack_public_path__ + "static/media/log-out.9f724533.svg";